const frenzy_get_product_json = async function(url, html){
  jQuery.getJSON(url, function(product) {
    document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
      const getVariantID = this_section.getAttribute("data-variantid");
      const getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
      const max_price = product.price_max;
      const min_price = product.price_min;
      var compare_price = '';
      var price = '<span> Starting at: </span>' + money_format_Frenzy(min_price, frenzy_shop_currency);
      this_section.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+price+'</span>';
      this_section.querySelector('.frenzy_product_price_sale').classList.add('is-sale');
      this_section.querySelector('.frenzy_product_price_compare').style.display = 'none';
    });
  })
}
window.FrenzyProductGridChangeCallBack = function(html,data){
   html.querySelector('.frenzy_product_price_meta').classList.add("FrenzyProductId_"+data.product_id);
  if(data?.sale != "on sale"){
    if(html.querySelector('.frenzy_product_tags')){
      html.querySelector('.frenzy_product_tags .frenzy_tag.sale_tag').style.display = 'none';
    }
  }
  if(data?.sale === "on sale"){
    html.querySelector('.frenzy_product_tags .frenzy_tag.sale_tag').style.display = 'block';
    const product_handle = data.org_prod_url.split("?");
    frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html).then(frenzy_product_response => {return frenzy_product_response});
  }

  const product_labels = data?.st_new_arrivals_label;
  let frenzyNewHTML = '';
  let frenzyNewLabel = '';
  (product_labels || []).forEach(function(label){
    if(label == 'NEW' || label == 'New' || label == 'new'){
      frenzyNewLabel += label;
    }
  })
  if(frenzyNewLabel){
    frenzyNewHTML += '<span class="frenzy_tag new_tag">' + frenzyNewLabel + '</span>';
    html.querySelector('.frenzy_product_tags').insertAdjacentHTML('afterEnd',frenzyNewHTML);
  }
};

document.querySelectorAll(".frenzy_search_suggest").forEach(function (this_click) {
  this_click.addEventListener("click", function (event) {
    event.preventDefault(), event.stopImmediatePropagation();
    document.querySelector('body')?.scrollIntoView({ behavior: "smooth" });
  })
})
window.frenzyAnimationCallBack = () => {
  let frenzyUpdatePlaceholder = '';
  const gridLength = 24;
  frenzyUpdatePlaceholder += '<div class="frenzy_collection_page_loader_content">';
  frenzyUpdatePlaceholder += '<div class="frenzy_container">';
  frenzyUpdatePlaceholder += '<div class="frenzy_topbar_loader_content">';
  frenzyUpdatePlaceholder += '<div class="frenzy_filter_loader_content "></div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_sorting_loader_content"></div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_empty_loader_content"></div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_orientation_loader_content">';
  frenzyUpdatePlaceholder += '<span></span>';
  frenzyUpdatePlaceholder += '<span></span>';
  frenzyUpdatePlaceholder += '<span></span>';
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_content_loader_row">';
  frenzyUpdatePlaceholder += '<div class="frenzy_sidebar_loader_content"><div class="frenzy_side_bar_filter_loader_content"><div class="frenzy_filter_title_loader"></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div></div><div class="frenzy_side_bar_filter_loader_content color_filter_loader"><div class="frenzy_filter_title_loader"></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div><div class="frenzy_filter_title_ct_loader"><div class="frenzy_filter_checkbox_loader"></div><div class="frenzy_filter_content_loader filter_animation_loader_frame"></div></div></div></div>';
  frenzyUpdatePlaceholder += '<div class="frenzy_loader_row loader_grid_3">';
  for(var i = 1; i <= gridLength; i++ ){
    frenzyUpdatePlaceholder += '<div class="frenzy_loader_grid">';
    frenzyUpdatePlaceholder += '<figure>';
    frenzyUpdatePlaceholder += '<img src="https://cdn.frenzyai.click/plugin/placeholder.png" />';
    frenzyUpdatePlaceholder += '</figure>';
    frenzyUpdatePlaceholder += '<p></p>';
    frenzyUpdatePlaceholder += '<span></span>';
    frenzyUpdatePlaceholder += '</div>';
  }
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '</div>';
  frenzyUpdatePlaceholder += '</div>';
  return frenzyUpdatePlaceholder;
}


